import { FC, useMemo } from 'react';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog } from './Dialog';
import { IActionsProps, IActionVariant } from './ButtonPanel';
import classNames from 'classnames';

export type AlertType = 'Error' | 'Warning' | 'Information';

export interface IAlertDialogProps {
  open: boolean;
  messages: string[];
  onClose: () => void;
  actionName?: string;
  title?: string;
  actionVariant?: IActionVariant;
  type: AlertType;
  /** `true` to replicate the behavior top-pinned error/warning dialogs */
  pinnedToTop?: boolean;
}

export const AlertDialog: FC<IAlertDialogProps> = ({
  messages,
  onClose,
  actionName,
  actionVariant,
  title,
  open,
  pinnedToTop,
  type,
}) => {
  const contentView = useMemo(() => {
    return messages.map((warning, ind) => {
      return (
        <DialogContentText className="dp-alert-dialog__text" key={ind} id={ind.toString()}>
          {warning}
        </DialogContentText>
      );
    });
  }, [messages]);

  const actions: IActionsProps[] = useMemo(() => [{ name: actionName || 'Dismiss', onClick: onClose }], [
    actionName,
    onClose,
  ]);

  const iconClasses = classNames({
    'dp-warning-dialog__icon': type === 'Warning',
    'dp-error-dialog__icon': type === 'Error',
    'dp-info-dialog__icon': type === 'Information',
  });

  const dialogPosition = pinnedToTop
    ? {
        top: 0,
      }
    : undefined;

  const margin = pinnedToTop ? 0 : undefined;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideTitle={pinnedToTop}
      dialogTitle={{ titleText: title }}
      dialogActions={{ actions, variant: actionVariant }}
      styles={{ minWidth: 350, margin }}
      disableFullScreenAction
      isResponsive
      className="dp-alert-dialog--pinned-to-top"
      contentClassName="dp-alert-dialog__content-holder"
      dialogPosition={dialogPosition}
    >
      <div className={iconClasses}></div>
      <div className="dp-alert-dialog__content"> {contentView} </div>
    </Dialog>
  );
};
